/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_Grades_DescInputs */

const en_gc_editor_grades_desc = /** @type {(inputs: Gc_Editor_Grades_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Averages, formulas and a little insight.`)
};

const zh_gc_editor_grades_desc = /** @type {(inputs: Gc_Editor_Grades_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平均分、公式与数据洞察。`)
};

/**
* | output |
* | --- |
* | "Averages, formulas and a little insight." |
*
* @param {Gc_Editor_Grades_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_grades_desc = /** @type {((inputs?: Gc_Editor_Grades_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_Grades_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_grades_desc(inputs)
	return zh_gc_editor_grades_desc(inputs)
});
export { gc_editor_grades_desc as "gc.editor.grades_desc" }